import { Component } from 'shimmer'

import { ballAssets } from '@/webGL/objects/BallAssets'

import {
  TextureLoader,
  MeshBasicMaterial,
  SphereGeometry,
  Mesh,
  Vector3,
  Euler
} from 'three'

const PI2 = Math.PI * 2
const worldX = new Vector3(1, 0, 0)
const worldZ = new Vector3(0, 0, 1)

export class Ball extends Component {
  constructor (radius = 2) {
    super('Ball')

    this.load()

    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve
      this.reject = reject
    })

    this.radius = radius
    this.isRolling = true
    this.perimeter = PI2 * this.radius

    const geometry = new SphereGeometry(this.radius, 50, 50)
    const material = new MeshBasicMaterial()
    this.object = new Mesh(geometry, material)
    this.object.castShadow = true
    this.lastPosition = this.object.position.clone()
    this.add(this.object)

    ballAssets.promise.then(() => {
      this.object.position.y = this.radius
      this.object.material.dispose()
      this.object.material = ballAssets.baseSphere.material.clone()
      this.object.material.envMap = ballAssets.envMap

      this.resolve()
    })
  }

  load () {
    const textureLoader = new TextureLoader()

    const promises = [
      new Promise(resolve => {
        this.aoMap = textureLoader.load('/images/textures/ball/Metal_scratched_008_ambientOcclusion.jpg', () => {
          resolve()
        })
      }),
      new Promise(resolve => {
        this.normalMap = textureLoader.load('/images/textures/ball/Metal_scratched_008_normal.jpg', () => {
          resolve()
        })
      }),
      new Promise(resolve => {
        this.roughnessMap = textureLoader.load('/images/textures/ball/Metal_scratched_008_roughness.jpg', () => {
          resolve()
        })
      }),
      new Promise(resolve => {
        this.metalnessMap = textureLoader.load('/images/textures/ball/Metal_scratched_008_metallic.jpg', () => {
          resolve()
        })
      })
    ]

    return Promise.all(promises)
  }

  onUpdate () {
    if (!this.object) {return}

    if (this.isRolling) {
      const delta = this.lastPosition.clone().sub(this.object.position)

      // console.log(delta.x)

      // this.object.rotateZ( (delta.x / this.perimeter) * PI2 )
      // this.object.rotateX( -(delta.z / this.perimeter) * PI2 )

      this.object.rotateOnWorldAxis( worldZ, (delta.x / this.perimeter) * PI2 )
      this.object.rotateOnWorldAxis( worldX, -(delta.z / this.perimeter) * PI2 )
      // this.object.rotateX( -(delta.z / this.perimeter) * PI2 )

      // this.object.rotation.applyEuler( new Euler( -(delta.z / this.perimeter) * PI2, 0, (delta.x / this.perimeter) * PI2, 'XYZ' ) )
      // this.object.rotation.z += (delta.x / this.perimeter) * PI2
      // this.object.rotation.x += (delta.x / this.perimeter) * PI2
    }

    this.lastPosition.copy(this.object.position)
  }

  onDestroy () {
    this.object.material.dispose()
    this.object.geometry.dispose()
    this.aoMap.dispose()
    this.normalMap.dispose()
    this.roughnessMap.dispose()
    this.metalnessMap.dispose()

    this.destroy()
  }
}

// export const ball = new Ball()